import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';

class SGKWorkerMonitorService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.MasterDomain + ApiUrl.controller.SGKWorkerMonitor);
    }

    /*  async register(data) {
        return await this.easyPost(ApiUrl.endpoint.Register, data);
    }*/

    async bulkReset(data) {
        return await this.easybulkPost(ApiUrl.endpoint.bulkReset, data);
    }

    async bulkSet(data) {
        return await this.easybulkPost(ApiUrl.endpoint.bulkSet, data);
    }

    async bulkResetJobOrWorker(data) {
        return await this.easyPost(ApiUrl.endpoint.bulkResetJobOrWorker, data);
    }

    async bulkSetJobOrWorker(data) {
        return await this.easyPost(ApiUrl.endpoint.bulkSetJobOrWorker, data);
    }

    async getMonitorJobSummary(data) {
        return await this.easyGet(ApiUrl.endpoint.getMonitorJobSummary, { jobId: data });
    }
}

const SGKWorkerMonitorservice = new SGKWorkerMonitorService();

export default SGKWorkerMonitorservice;